<template>
  <div >
    <app-banner :res="indexData.banner"></app-banner>
    <index-schedule :res="indexData"></index-schedule>
    <index-video v-if="$store.state.show.video"></index-video>
    <index-image v-if="$store.state.show.image"></index-image>
    <index-news v-if="$store.state.show.news"></index-news>
    <!-- <index-social ></index-social>  -->
    <index-echart v-if="indexData" :res="indexData"></index-echart>
    <!-- <index-guests :res="indexData.jiabing"></index-guests> -->
    
    <index-font :res="{title:indexData.title,about:indexData.about}"></index-font>
    <home-swiper-2 :res="indexData.footswiper"></home-swiper-2>
  </div>
</template>

<script>
import header from "../public/header.vue";
import banner from "../index/banner.vue";
import homeSwiper2 from "../home-swiper-2.vue";
// import footer from "../public/footer.vue";
import indexVideo from "../index/video.vue";
import indexImage from "../index/image.vue";
import indexNews from "../index/news.vue";
import indexSocial from "../index/social.vue";
import indexFont from "../index/font.vue";
import indexGuests from "../index/guests.vue";
import indexSchedule from "../index/schedule.vue";
import indexEchart from "../index/echart.vue";
export default {
  name: "app",
  data() {
    return {
      indexData:{},
      defaultData:{}
    }
  },
  components: {
    "app-header": header,
    "app-banner": banner,
    homeSwiper2,
    indexVideo,
    indexImage,
    indexNews,
    indexSocial,
    indexFont,
    indexGuests,
    indexSchedule,
    indexEchart
  },created() {
    this.$http.get('/Index/Config/data&key=home').then(res=>{
      this.indexData = res.value;
    })
   
    
  },
};
</script>